import User from '@modules/User/Domain/User'
import UserApiResponse from '@modules/User/Infrastructure/Repository/UserApiResponse'

export const toUserDto = (data: UserApiResponse): User => {
  return {
    name: data.displayName,
    email: data.name,
    groups: data.groups
  }
}